// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// JS Imports
import {
   //@ts-ignore
   formatFloatAsCurrencySymbol,
   //@ts-ignore
   formatFloatAsPercent,
} from '../../../common/helpers.mjs'
//@ts-ignore
import { substituteDiscountNameVariable } from '../../../common/calculate.mjs'
// Type imports
//@ts-ignore
import { type AppliedDiscount } from '../../../common/types/calculatedValues'
import { type IQuoteContext } from '../../../ts/QuoteContext'

// Define the props interface for the component
interface TotalHeroDiscountRowProps {
   discountCode: string
}

function TotalHeroDiscountRow(props: TotalHeroDiscountRowProps) {
   //TODO: change this to the proper typing once we migrate App.jsx to Typescript
   const state = useQuoteContext()
   //Checks if the provided discount is a hero discount
   if (state?.discount_list?.[props.discountCode]?.HeroDiscount) {
      const DiscountName = substituteDiscountNameVariable(
         props.discountCode,
         state?.discount_list,
         state?.selectedProductCosts,
         state?.product_list,
      )
      const isPercent =
         state?.discount_list?.[props.discountCode]?.DiscountType === 'percent'
      const DiscountAmount =
         state?.discount_list?.[props.discountCode]?.DiscountAmount
      const isMonthly =
         state?.discount_list?.[props.discountCode]?.BillingFreq === 'monthly'
      const ChangeInCurrency = isMonthly
         ? (state?.monthlyTotal?.appliedDiscounts?.find(
              (discount: AppliedDiscount) =>
                 discount.DiscountCode === props.discountCode,
           )?.total ?? 0)
         : (state?.oneTimeTotal?.appliedDiscounts?.find(
              (discount: AppliedDiscount) =>
                 discount.DiscountCode === props.discountCode,
           )?.total ?? 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>{DiscountName}</div>
            <div className='col col-bhr-red'></div>
            <div className='col col-bhr-red'>
               {isPercent && (
                  <span>{formatFloatAsPercent(DiscountAmount)}</span>
               )}
            </div>
            <div className='col col-bhr-red'>
               {formatFloatAsCurrencySymbol(
                  ChangeInCurrency,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
   }
   return null // Return null when the discount is not a hero discount
}

export default function TotalHeroDiscountRows() {
   //TODO: change this to the proper typing once we migrate App.jsx to Typescript
   const state = useQuoteContext()
   const HeroDiscounts = Object.keys(state?.discount_list ?? {}).filter(
      (discountCode) => state?.discount_list?.[discountCode]?.HeroDiscount,
   )
   //TODO: Fix types
   //@ts-ignore
   const SelectedHeroDiscounts = HeroDiscounts.filter(
      (discountCode) => state?.promotionalDiscounts?.[discountCode],
   )
   return (
      <div>
         {SelectedHeroDiscounts.map((discountCode) => (
            <TotalHeroDiscountRow
               key={discountCode}
               discountCode={discountCode}
            />
         ))}
      </div>
   )
}
